import React, { useEffect, useState } from "react";
import { useOutlet } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import RatingModal from "../components/modal/RatingModal";
import { RequestReviewType, requestReviewState } from "../recoil/socket";
import SurpriseModal from "../components/modal/SurpriseModal";
import { eventState, EventStateType } from "../recoil/event";

export const MainLayout = (oProps: any) => {
  const event = useRecoilValue<EventStateType>(eventState);

  const outlet = useOutlet();
  const [visibleRating, setVisibleRating] = useState<boolean>(false);
  const [ratingInfo, setRatingInfo] = useRecoilState<RequestReviewType | null>(
    requestReviewState
  );

  useEffect(() => {
    if (ratingInfo !== null) {
      setVisibleRating(true);
    }
  }, [ratingInfo]);

  return (
    <Style>
      <div className="screen">{outlet}</div>

      <RatingModal
        isVisible={visibleRating}
        setVisible={setVisibleRating}
        ratingInfo={ratingInfo}
        setRatingInfo={setRatingInfo}
      />
      <SurpriseModal event={event} />
    </Style>
  );
};

export const Style = styled.div`
  .screen {
    width: 100%;
    height: 100%;
    min-height: auto;
  }
`;
